import * as app_consts from "../../constants/react_app_consts";
import { findModuleAction } from "../../utils/functionalUtils";

export const getStoredMenuAccountActions = () => {
  if (!localStorage.getItem("log_cred")) {
    return [];
  }

  try {
    return JSON.parse(localStorage.getItem("log_cred"))?.user_actions || [];
  } catch (error) {
    console.error("Failed to parse menu account actions.", error);
    return [];
  }
};

const createWarehouseMenuItems = () => [
  {
    heading: "Warehouse Management",
  },
  {
    text: "Goods Received",
    link: "/dashboard/goods_received",
    icon: "arrow-down-round",
  },
  {
    text: "Schedules",
    link: "/dashboard/grn_schedule",
    icon: "clock",
  },
  {
    text: "Loading Orders",
    icon: "card-view",
    link: "/dashboard/loading_orders",
  },
  {
    text: "Delivery Notes",
    link: "/dashboard/delivery_notes",
    icon: "arrow-up-round",
  },
  {
    icon: "truck",
    text: "Weighbridge Tickets",
    link: "/dashboard/weighbridge/tickets",
  },
  {
    icon: "file-docs",
    text: "Smart Invoices",
    active: false,
    link: "/dashboard/smart_invoices",
    subMenu: [
      {
        text: "Invoices",
        link: "/dashboard/smart_invoices",
        icon: "file-docs",
      },
      {
        text: "Inventory",
        link: "/dashboard/smart_invoices/inventory",
        icon: "package-fill",
      },
    ],
  },
];

export const getMenuData = (options = {}) => {
  const { accountActions: providedAccountActions, strictPermissions = false } = options;
  const account_actions = Array.isArray(providedAccountActions)
    ? [...providedAccountActions]
    : [...getStoredMenuAccountActions()];
  const hasWarehouseModule = account_actions.some((module) => module?.module_name === app_consts.WAREHOUSE_MANAGEMENT);
  const menu_data = [
    {
      icon: "dashboard-fill",
      text: "Dashboard",
      link: `/dashboard`,
    },
  ];

  if (!strictPermissions || account_actions.length === 0 || hasWarehouseModule) {
    menu_data.push(...createWarehouseMenuItems());
  }

  if (account_actions.length === 0) {
    return menu_data;
  }

  const sortOrder = [
    "warehouse_management",
    "onboarding",
    "user_management",
    "system_management",
  ];

  account_actions.sort((a, b) => sortOrder.indexOf(a.module_name) - sortOrder.indexOf(b.module_name));

  account_actions.forEach((module) => {
    if (module.module_name === app_consts.WAREHOUSE_MANAGEMENT) {
      if (findModuleAction(app_consts.VIEW_WAREHOUSE_INVENTORY, module)) {
        menu_data.push({
          text: "Stock Levels",
          icon: "card-view",
          link: "/dashboard/warehouse_inventory",
        });
      }
    }

    if (module.module_name === app_consts.ONBOARDING) {
      if (
        findModuleAction(app_consts.ONBOARD_USER, module) ||
        findModuleAction(app_consts.ONBOARD_COMPANY, module)
      ) {
        menu_data.push({ heading: "OnBoarding" });

        menu_data.push({
          text: "User Onboarding",
          icon: "users",
          link: "/dashboard/onboarding/user",
        });
      }
    }

    if (module.module_name === app_consts.USER_MANAGEMENT) {
      if (
        findModuleAction(app_consts.VIEW_USERS, module) ||
        findModuleAction(app_consts.VIEW_USER_ACCOUNTS, module)
      ) {
        const subMenu = [];

        menu_data.push({ heading: "System Users" });

        if (findModuleAction(app_consts.VIEW_USERS, module)) {
          subMenu.push({
            text: "User List",
            link: "/dashboard/user",
            icon: "user-list",
          });
        }

        if (findModuleAction(app_consts.VIEW_USER_ACCOUNTS, module)) {
          subMenu.push({
            text: "User Account List",
            link: "/dashboard/user/accounts",
            icon: "user-check-fill",
          });
        }

        menu_data.push({
          icon: "users",
          text: "Users",
          active: false,
          subMenu,
        });
      }
    }

    if (module.module_name === app_consts.SYSTEM_MANAGEMENT) {
      const employeeSubMenu = [
        {
          text: "Employees",
          link: "/dashboard/admin/employees",
          icon: "user-alt",
        },
      ];

      if (findModuleAction(app_consts.VIEW_DEPARTMENTS_AND_ROLES, module)) {
        employeeSubMenu.push({
          text: "Departments and Roles",
          link: "/dashboard/admin/departments_and_roles",
          icon: "package-fill",
        });
      }

      menu_data.push(
        { heading: "Admin Panel" },
        {
          icon: "account-setting",
          text: "Employees",
          active: false,
          link: "/dashboard/admin",
          subMenu: employeeSubMenu,
        },
        {
          icon: "history",
          text: "Audit Trails",
          link: "/dashboard/admin/audit_trails",
        },
      );

      module?.module_actions?.forEach((action) => {
        if (action.module_action_name === app_consts.VIEW_BRANCH_LOCATIONS) {
          menu_data.push({
            icon: "building",
            text: "Branch Locations",
            active: false,
            link: "/dashboard/admin",
            subMenu: [
              {
                text: "Branch Locations",
                link: "/dashboard/admin/branch_locations",
                icon: "building-fill",
              },
            ],
          });
        }
      });

      if (
        findModuleAction(app_consts.VIEW_PRODUCT, module) ||
        findModuleAction(app_consts.VIEW_PRODUCT_TYPE, module) ||
        findModuleAction(app_consts.VIEW_UNIT_MEASUREMENT, module)
      ) {
        const productSubMenu = [];

        if (findModuleAction(app_consts.VIEW_PRODUCT, module)) {
          productSubMenu.push({
            text: "Products",
            link: "/dashboard/admin/products",
            icon: "package-fill",
          });
        }

        if (findModuleAction(app_consts.VIEW_PRODUCT_TYPE, module)) {
          productSubMenu.push({
            text: "Product Types",
            link: "/dashboard/admin/product_types",
            icon: "package-fill",
          });
        }

        if (findModuleAction(app_consts.VIEW_UNIT_MEASUREMENT, module)) {
          productSubMenu.push({
            text: "Unit Measurements",
            link: "/dashboard/admin/unit_measurements",
            icon: "meter",
          });
        }

        menu_data.push({
          icon: "note-add",
          text: "Products",
          link: "/dashboard/admin",
          active: false,
          subMenu: productSubMenu,
        });
      }
    }
  });

  return menu_data;
};

export default getMenuData();
